/**
 * NOTE: This script is intended to be run in a browser.
 * WARNING: Including your Admin API Token here is INSECURE and will expose your store to risks.
 * Ideally, this data should be fetched from a secure backend or a Metafield.
 */

const SHOP = 'ab08c3-2.myshopify.com';
const TOKEN = ''; // ⚠️ INSECURE: Do not use in production!
const API_VERSION = '2024-01';

async function getProductSalesCount(productId) {
  if (!productId) return;

  let totalSold = 0;
  let url = `https://${SHOP}/admin/api/${API_VERSION}/orders.json?status=any&limit=250`;

  try {
    while (url) {
      const response = await fetch(url, {
        headers: {
          'X-Shopify-Access-Token': TOKEN,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) throw new Error('API Error');

      const data = await response.json();
      const orders = data.orders || [];

      orders.forEach(order => {
        order.line_items.forEach(item => {
          if (String(item.product_id) === String(productId)) {
            totalSold += item.quantity;
          }
        });
      });

      // Pagination
      const linkHeader = response.headers.get('link');
      if (linkHeader && linkHeader.includes('rel="next"')) {
        const matches = linkHeader.match(/<([^>]+)>;\s*rel="next"/);
        url = matches ? matches[1] : null;
      } else {
        url = null;
      }
    }
    return totalSold;
  } catch (error) {
    console.error('Sales Count Fetch Error:', error);
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const badge = document.querySelector('.sales-badge-dynamic');
  if (badge) {
    const productId = badge.dataset.productId;
    getProductSalesCount(productId).then(count => {
      if (count !== undefined) {
        badge.querySelector('.count-placeholder').textContent = count;
        badge.style.display = 'inline-flex';
      }
    });
  }
});
